module.exports = __webpack_public_path__ + "static/media/refer_friend_new.de67d0e6.png";